import { ComponentManager, UIListener } from 'radpresentation.htmlclient.defaultviewextensions';

class BenutzerUIListener extends UIListener
{
    constructor() {
        super();
        this.createChain(
            'UserUIListener',
        );
    }
}

ComponentManager.setUIListener('BenutzerUIListener', BenutzerUIListener, 'ONVHTMLViewExtension');
